import {override} from "mobx";
import {ACTION_TYPES} from "../../../../../core/consts";
import {APP, SPORT_TYPES} from "../../../../../core/app/consts";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {GameCenterTabModel} from "./game-center.tab-model";

export class GameCenterLineupsTabModel extends GameCenterTabModel {
  @override get isVisible(): Boolean {
    const notValidSportTypes = [SPORT_TYPES.baseball];
    const isVisible = !notValidSportTypes.includes(this.entity.sport.id) && (this.entity.hasLineups || this.entity.hasMissingPlayers);

    return isVisible;
  }

  get eventName(): String {
    return ACTION_TYPES.lineupsClick;
  }

  get eventParams(): Object {
    const eventParams = {
      gameId: this.entity.id,
      entityId: this.entity.id,
      status: this.entity.statusGroup,
      source: APP.ANALYTICS.SOURCES.gameCenterTabs,
      entityType: ANALYTICS.ENTITY_TYPES.game,
    }

    return eventParams;
  }

  get analyticsName(): Object {
    return ANALYTICS.TAB_NAMES.lineups;
  }
  get elementId(): String {
    return 'navigation-tabs_game-center_lineups';
  }
}
